import { observer } from 'mobx-react';
import * as React from 'react';
import { Panel, Table } from 'react-bootstrap';
import * as ApiTypes from '../../../../models/ApiTypesBps2021';
import { numberformat } from '../../../../utils/numberformat';

class BpsReferenzkraftGesamtBeurteilungMesspunkt extends React.Component<{messpunkt: ApiTypes.IBpsReferenzkraftGesamtMesspunkt}, {}> {
  render() {
    const { messpunkt } = this.props;
    let beurteilung = '-';
    let className = '';
    if (messpunkt.bewertung !== null) {
      beurteilung = messpunkt.bewertung ? 'i.O.' : 'n.i.O.';
      className = `beurteilung-${beurteilung.replace(/\./g, '').toLowerCase()}`;
    }
    return (
      <tr>
        <td>{messpunkt.kraftstufe}</td>
        <td>{messpunkt.absolut}</td>
        <td>{messpunkt.relativ !== null ? numberformat(messpunkt.relativ) : ''}</td>
        <td><div className={className}>{beurteilung}</div></td>
      </tr>);
  }
}

/** Komponente zum Anzeige der Gesamtbeurteilung der Messwerte (Abgleich Links/Rechts) für die Kalibrierung von Bremsprüfständen */
@observer
export default class BpsReferenzkraftGesamtBeurteilung extends React.Component<{ ziel: ApiTypes.IBpsReferenzKraftGesamtErgebnis; nachJustage: boolean; }, {}> {

  render() {
    let header = 'Konformitätsbewertung - Abweichung Links/Rechts';
    if (this.props.nachJustage) {
      header += ' nach Justage';
    }

    if (this.props.ziel.length === 0) {
      return (
        <Panel header={header} collapsible={true} defaultExpanded={true}>
          <div>Es konnte noch kein Gesamtergebnis ermittelt werden</div>
        </Panel>
      );
    }
    return (
      <Panel header={header} collapsible={true} defaultExpanded={true}>
        <Table striped={false} bordered={false} condensed={true} hover={false} className="bps-auswertung">
          <thead>
            <tr>
                <th>Kraftstufe</th>
                <th>Abweichung [N]</th>
                <th>Abweichung [%]</th>
                <th style={{width: '48px'}}/>
            </tr>
          </thead>
          <tbody>
            {this.props.ziel.map((mp, index) => (
              <BpsReferenzkraftGesamtBeurteilungMesspunkt messpunkt={mp} key={index}/>
            ))}
          </tbody>
        </Table>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/bps/rili2021/BpsReferenzkraftGesamtBeurteilung.tsx